import { useEffect, useState } from "react";
import { Modal, Button, Table, ButtonGroup } from "react-bootstrap";
import { FormAction } from "../../forms/interfaces/form-input.interface";
import PageHeaderComponent from "../../home/components/page-header.component";
import { UserOrganizationData } from "../interfaces/user-organization-result.interface";
import {
  useUserOrganizationFormStore,
  useUserOrganizationStore,
} from "../states/user-organization.state";
import ReactPaginate from "react-paginate";
import FormsComponent from "../../forms/components/forms.component";

const UserOrganizationScreen = () => {
  const {
    getUserOrganizations,
    userOrganizations,
    userOrganizationModel,
    userOrganizationLoading,
    deleteUserOrganization,
  } = useUserOrganizationStore();
  const {
    submitDone,
    formLoading,
    forms,
    setForms,
    generateForms,
    setFormSelectData,
    onSubmitForm,
    formParam,
  } = useUserOrganizationFormStore();
  const [show, setShow] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [size, setSize] = useState<number>(10);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleEdit = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    item: UserOrganizationData
  ) => {
    generateForms({
      action: FormAction.UPDATE,
      title: "User Organization",
      subtitle: "Ubah User Organization",
      id: item.id,
      data: item,
    });
    handleShow();
  };

  const handleView = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    item: UserOrganizationData
  ) => {
    generateForms({
      action: FormAction.VIEW,
      title: "User Organization",
      subtitle: "Lihat User Organization",
      id: item.id,
      data: item,
    });
    handleShow();
  };

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected;
    setPage(selectedPage);
  };

  useEffect(() => {
    getUserOrganizations({
      size: size,
      page: page,
    });
  }, [page]);

  useEffect(() => {
    console.log(submitDone);
    if (submitDone !== undefined) {
      if (submitDone) {
        handleClose();
        generateForms({
          action: FormAction.CREATE,
          title: "User Organization",
          subtitle: "Tambah User Organization",
        });
        getUserOrganizations({
          size: 20,
          page: 0,
        });
      }
    }
  }, [submitDone]);

  return (
    <>
      <PageHeaderComponent
        title="User Organization"
        subtitle="Daftar User Organization"
        hasButton={true}
        buttonTitle="Tambah"
        onClick={(e) => {
          generateForms({
            action: FormAction.CREATE,
            title: "User Organization",
            subtitle: "Create User Organization",
            data: undefined,
            id: undefined,
          });
          handleShow();
        }}
      />
      <div className="row">
        <div className="col-md-12 col-lg-12">
          <div className="card">
            <div className="card-body">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th className="wd-1p">No</th>
                    <th className="wd-15p">Name</th>
                    <th className="wd-3p" style={{ width: 50 }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {userOrganizationLoading && (
                    <tr>
                      <td colSpan={7}>Loading</td>
                    </tr>
                  )}
                  {userOrganizations.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>
                          <ButtonGroup aria-label="Basic example">
                            <Button
                              variant="primary"
                              onClick={(e) => handleView(e, item)}
                            >
                              Lihat
                            </Button>
                            <Button
                              variant="warning"
                              onClick={(e) => handleEdit(e, item)}
                            >
                              Ubah
                            </Button>
                            <Button
                              variant="danger"
                              onClick={(e) => {
                                e.preventDefault();
                                const response = window.confirm(
                                  "Apakah yakin ingin menghapus data ini ?"
                                );
                                if (response === true) {
                                  deleteUserOrganization(item.id);
                                }
                              }}
                            >
                              Hapus
                            </Button>
                          </ButtonGroup>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <div className="card-footer">
              <ReactPaginate
                previousLabel={"«"}
                nextLabel={"»"}
                breakLabel={"..."}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                pageCount={userOrganizationModel?.data?.total_pages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={10}
                onPageChange={handlePageClick}
                containerClassName={"pagination pagination-sm m-0 float-right"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} size={"lg"}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmitForm();
          }}
        >
          <Modal.Header>
            <Modal.Title>{formParam?.subtitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormsComponent forms={forms} setForms={setForms} />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={(e) => {
                if (!formLoading) handleClose();
              }}
              className={formLoading && "btn-loading"}
            >
              Close
            </Button>
            <Button
              variant="danger"
              className={formLoading && "btn-loading"}
              onClick={(e) => {
                e.preventDefault();
                if (!formLoading) onSubmitForm();
              }}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default UserOrganizationScreen;
